import { Component, OnInit, ViewChild } from '@angular/core';
import { PotentialJobsWorkingCommentsService } from 'src/app/service/potential-jobs-working-comments/potential-jobs-working-comments.service';
import { MomentService } from 'src/app/service/shared/moment/moment.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
import { PdfService } from 'src/app/service/pdf/pdf.service';

@Component({
  selector: 'app-pdf-generate',
  templateUrl: './pdf-generate.component.html',
  styleUrls: ['./pdf-generate.component.scss'],
})
export class PdfGenerateComponent implements OnInit {
  @ViewChild('pdfMarkup') pdfMarkup;
  @ViewChild('startDate') startDate;
  @ViewChild('endDate') endDate;

  projectName: string;
  jobNumber: string;
  department: string;
  messagesLoaded: boolean;

  messages;
  messageGroups = [];
  jobId: any;
  commentType: string;
  pdfForm: FormGroup;
  model = new FormControl();
  starterDate;
  egan_hub_site_logo = '../../../assets/images/logo/ae_logo.png';
  constructor(
    private formBuilder: FormBuilder,
    private potentialJobsWorkingCommentsService: PotentialJobsWorkingCommentsService,
    private momentService: MomentService,
    private loaderService: LoaderService,
    private pdfService: PdfService,
  ) {}

  ngOnInit(): void {
    this.pdfForm = this.formBuilder.group({
      startDate: '',
      endDate: '',
    });
  }

  ngOnChanges(): void {}

  updateParams(jobId, commentType, projectName, jobNumber, department) {
    this.jobId = null;
    this.commentType = null;
    this.projectName = null;
    this.department = null;

    if (jobId && commentType) {
      this.jobId = jobId;
      this.commentType = commentType;
      this.projectName = projectName;
      this.jobNumber = jobNumber;
      this.department = department;
    }
  }

  //To get all potential jobs working comments
  getMessages(jobId, commentType, options) {
    return new Promise((resolve, reject) => {
      //Service call to get filtered working comments data
      this.potentialJobsWorkingCommentsService
        .getPotentialJobsWorkingCommentsByJobId(jobId, commentType, options)
        .subscribe(
          res => {
            this.onGetMessagesSuccess(res);
            resolve(true);
          },
          error => {
            this.onGetMessagesError(error);
            reject(false);
          },
        );
    });
  }

  onGetMessagesSuccess(result) {
    if (!result?.data) return;

    this.messages = result.data;
    let lastDate = null;
    let currentDate = null;

    let dateIndex = -1;
    this.messages.forEach(msg => {
      const tempDate = new Date(msg.created_date);
      tempDate.setHours(0);
      tempDate.setMinutes(0);
      tempDate.setSeconds(0);
      tempDate.setMilliseconds(0);

      const dt = this.momentService.getGeneralDateFormat(msg.created_date, 'MMMM D YYYY|h:mm A').split('|');
      const date = dt[0];
      const time = dt[1];

      currentDate = tempDate.valueOf();
      if (lastDate !== currentDate) {
        dateIndex += 1;
        this.messageGroups.push({ date, messages: [] });
      }

      this.messageGroups[dateIndex].messages.push({
        sender: msg.user_name,
        text: msg.comment,
        time: time,
      });
      lastDate = currentDate;
    });

    this.messagesLoaded = true;
  }

  //On error of working status api call
  onGetMessagesError(_) {}

  async save() {
    this.loaderService.displayLoader();
    this.messageGroups.length = 0; // reset array

    if (!this.jobId) return;

    const msgOptions = {
      includeInvoices: 1,
      sortField: 'jwc.created_date',
      sortOrder: 'DESC',
    };

    const [startMonth, startDay, startYear] = this.momentService
      .getGeneralDateFormat(this.pdfForm.get('startDate').value, 'MM/DD/YYYY')
      .split('/');
    const [endMonth, endDay, endYear] = this.momentService
      .getGeneralDateFormat(this.pdfForm.get('endDate').value, 'MM/DD/YYYY')
      .split('/');

    const rangeStart = startMonth && `${startYear}-${startMonth}-${startDay}`;
    const rangeEnd = endMonth && `${endYear}-${endMonth}-${endDay} 23:59:59`;

    if (rangeStart || rangeEnd) {
      msgOptions['dateRange'] = `${rangeStart}|${rangeEnd}`;
    }

    await this.getMessages(this.jobId, this.commentType, msgOptions);
    await this.html2Pdf();
  }

  async html2Pdf() {
    try {
      const today = this.momentService.getGeneralDateFormat('', 'YYYYMMDD');
      const filename = `${this.jobNumber}_${this.commentType}_${today}.pdf`;

      const commentTitle = this.commentType === 'job' ? 'Job' : 'Accounting';
      const headerTitle = `${this.projectName} - ${commentTitle} Comments`;

      const content = {
        data: this.messageGroups,
        headerTitle,
        jobNumber: this.jobNumber,
        department: this.department,
      };

      await this.pdfService.saveToPdf(filename, content, 'invoice');
    } catch (error) {
      console.error('GENERATE PDF ERROR:', error);
    } finally {
      this.loaderService.hideLoader();
    }
  }

  setData(field: string, value: unknown) {
    this.pdfForm.get(field).setValue(value);
  }
}
